import React, { FC } from 'react';
import styled from 'styled-components';
import { Link } from '../Common';
import Typography from '../Typography';

const InteractiveRowWrapper = styled.div<{ highlightBorder?: boolean; activeBorderColor?: string }>`
  background: var(--sys-color--surface);
  border-radius: 16px;
  width: 100%;
  box-sizing: border-box;

  ${({ highlightBorder, activeBorderColor }) =>
    highlightBorder &&
    `
      border: 2px solid ${activeBorderColor || 'var(--sys-color--primary)'};
    `}

  > a {
    display: flex;
    flex-direction: row;
    align-items: center;
    text-decoration: none;
    width: 100%;
    gap: 16px;
  }
`;

const CardLink = styled(Link)`
  display: flex;
  flex-direction: row;
  align-items: center;
  text-decoration: none;
  width: 100%;
  cursor: pointer;
  box-sizing: border-box;
  gap: 16px;
`;

const TruncatedTypography = styled(Typography)`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
`;

interface ItemRowProps {
  photo: React.ReactNode;
  title: string;
  subtitle?: string;
  linkTo: string;
  pageDirection?: 'FORWARD' | 'BACKWARD';
  highlightBorder?: boolean;
  activeBorderColor?: string;
  onClick?: () => void;
  id?: string;
}

export const ItemRow: FC<ItemRowProps> = ({
  photo,
  title,
  subtitle,
  linkTo,
  pageDirection = 'FORWARD',
  highlightBorder = false,
  activeBorderColor,
  onClick,
  id,
}) => {
  return (
    <InteractiveRowWrapper highlightBorder={highlightBorder} activeBorderColor={activeBorderColor}>
      <CardLink
        to={linkTo}
        pageDirection={pageDirection}
        id={id}
        aria-label={id}
        onClick={onClick}
      >
        {photo}
        <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
          <TruncatedTypography variant="labelLarge" color="var(--sys-color--on-surface)">
            {title}
          </TruncatedTypography>
          {subtitle && (
            <Typography variant="bodySmall" color="var(--sys-color--on-surface-variant)">
              {subtitle}
            </Typography>
          )}
        </div>
      </CardLink>
    </InteractiveRowWrapper>
  );
};

export default ItemRow;
